import * as React from 'react';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import DoneIcon from "../../images/icon_done.png";

const styles = (theme: Theme) => createStyles({
  infoListItem: {
    '& > div:first-child': {
      color: 'white',
      fontSize: '1.375em',
      fontWeight: 'bold',
      lineHeight: 2.09,
      letterSpacing: '0.0359em'
    },
    '& > div:last-child': {
      marginBottom: '0.625em'
    }
  },
  doneIconContainer: {
    marginRight: '1.25em',
    marginTop: '1.25em'
  },
  doneIcon: {
    width: '3.702em'
  }
});

interface InfoListItemProps {
  title: string;
  content: string;
}

const InfoListItem: React.SFC<WithStyles & InfoListItemProps> = ({
  classes,
  title,
  content
}) => {
  return (
    <Grid item container>
      <Grid item className={classes.doneIconContainer}>
        <img src={DoneIcon} className={classes.doneIcon} />
      </Grid>
      <Grid item xs container direction="column" className={classes.infoListItem}>
        <Grid item>{title}</Grid>
        <Grid item>{content}</Grid>
      </Grid>
    </Grid>
  );
}

export default withStyles(styles)(InfoListItem);



// WEBPACK FOOTER //
// ./src/landingPage/components/InfoListItem.tsx